import { Link } from 'react-router';
import styles from './pages.module.css';

export function NotFoundPage() {
  return (
    <main className={styles.centered}>
      <h1 className={styles.heading}>Página não encontrada</h1>
      <p className={styles.muted}>O endereço não existe ou foi movido.</p>
      <Link className={styles.back} to="/">
        Ir para as conversas
      </Link>
    </main>
  );
}
